module.exports = __webpack_public_path__ + "img/photo-07.0b3ed9bb.png";